module.exports = __webpack_public_path__ + "media/comment_ca_marche/dessin1-de707e5d.png";